import { AutoMap } from "@automapper/classes"

export class PortfolioDTO {
    @AutoMap()
    samplingPointCode: string = ''
    @AutoMap()
    samplingPointName: string = ''
    @AutoMap()
    samplingPointAddress: string = ''
    @AutoMap()
    samplingPointAdditionalAddress: string = ''
    @AutoMap()
    samplingPointCity: string = ''
    @AutoMap()
    samplingPointZipCode: string = ''
    @AutoMap()
    clientCode: string = ''
    @AutoMap()
    clientName: string = ''
    @AutoMap()
    partnerCode: string = ''

}